import React from "react";
import {CartItem} from "Api/Query/CartQuery";
import {formatMoneyValue} from "Components/Money/MoneyAmount";
import {DISCOUNT_TYPE_ORDINARY_ID} from "Components/InscriptionOrder/DiscountTypeSelect";

interface Props{
    item: CartItem|any,
    inscription?: any,
    renderDaysAndServices?: boolean
}

export const CartItemSpecifications: React.FC<Props> = (props) => {

    const showDaysAndServices = props.renderDaysAndServices !== false

    function createActivityContent(item: CartItem, inscription: any = null) {
        let description = `
            <strong>Nombre del menor:</strong> ${item.child.name} ${item.child.surnames ?? ''}<br /> 
            <strong>Centro:</strong> ${item.center.name}<br />`

        if(item.courseLevel){
            description += `<strong>Curso:</strong> ${item.courseLevel.name}<br />`
        }

        description += `<strong>Actividad:</strong> ${item.name}<br />`

        if (item.activitySession) {
            description += `<strong>Modalidad:</strong> ${item.activitySession.name}`
        }

        if (showDaysAndServices) {
            // days
            description += `<br /><strong>Días:</strong><br /><ul>`
            item.days.map(day => {
                const dayValue = ('name' in day) ? day.name : day
                let priceLabel = ': ' + formatMoneyValue(day.price)
                let price = (item.initDate || !item.activitySession) ? '' : priceLabel
                price = (item.activity?.canSelectMultipleYearDays===true) ? priceLabel : price

                description += `<li><strong>${dayValue}</strong>${price}</li>`
            })
            description += '</ul>'

            if (item.services.length) {
                description += `<strong>Servicios:</strong><br /><ul>`

                item.services.map(service => {
                    description += `<li><strong>${service.name}</strong>: ${formatMoneyValue(service.price)}</li>`
                })

                description += `</ul>`
            }
        }

        if(item.initDate){
            const pendingMessage = 'Pendiente hasta la validación por el Servicio de Educación, que avisará a la familia de la fecha de incorporación'
            const initDate = (item.activitySession.id === '01925120-15e6-7237-acad-2070bfef156e') ? pendingMessage : item.initDate
            if (!showDaysAndServices && item.activitySession) {
                description += '<br />'
            }
            description += `<strong>Fecha de Inicio:</strong> ${initDate}`
        }

        const isOrdinaryDiscount = inscription?.discount.id === DISCOUNT_TYPE_ORDINARY_ID

        if((inscription?.discount && !isOrdinaryDiscount) || item.extraDiscount?.value)
        {
            description += '<br /><strong>Descuentos:</strong><ul>'

            if(!isOrdinaryDiscount && inscription?.discount){
                description += `<li>${inscription.discount.name}: <span class="text-danger">-${formatMoneyValue(item.discountAmount)}</span></li>`
            }

            if(item.extraDiscount){
                description += `<li>${item.extraDiscount.name}: <span class="text-danger">-${formatMoneyValue(item.extraDiscount.amount)}</span></li>`
            }

            description += '</ul>'
        }

        if(item.observations){
            description += `<br /><strong>Observaciones:</strong><p>${item.observations}</p>`
        }

        return {__html: description};
    }

    return (
        <>
            <span className={"purple d-block"}>{props.item.name}</span>
            <div dangerouslySetInnerHTML={createActivityContent(props.item, props.inscription ?? null)}></div>
        </>
    )

}
